module.exports = {
   BASE_ASSET_URL: 'https://raw.githubusercontent.com/Jon-k-1232/GeneralFiles/master/JKA_React'
};
